"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const useStyles = styles_1.makeStyles(() => ({
    box: {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    container: {
        position: 'relative',
        display: 'inline-flex',
    },
}));
const CircularProgressWithLabel = (props) => {
    const classes = useStyles();
    return (react_1.default.createElement(core_1.Box, { className: classes.container },
        react_1.default.createElement(core_1.CircularProgress, Object.assign({ variant: "determinate" }, props, { size: 80 })),
        react_1.default.createElement(core_1.Box, { className: classes.box },
            react_1.default.createElement(core_1.Typography, { variant: "caption", component: "div" }, `${Math.round(props.value)}%`))));
};
exports.default = CircularProgressWithLabel;
